module.exports = __webpack_public_path__ + "static/media/website-collage-desktop.df9913ee.jpg";